//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operation', {
//        templateUrl: 'views/components/views/operation/operation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'operationService', 'logisticService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, operationService, logisticService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationId = $stateParams.operation_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                operationId: operationId,
//                prodIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno }) }
//                ],
//                edit: {},
//                selectListUnits: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await operationService.getOperation({ operation_id: operationId }))[0];
//            }

//            async function loadUnits() {
//                vm.model.selectListUnits = await logisticService.listUnits({ onlytimeunits: '1' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.searchProduct({ prod_name: vm.model.edit[id] || '' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'prod_name':
//                        if (item) {
//                            vm.model.edit.prod_id = item?.item_id ?? '';
//                            vm.model.edit.prod_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('prod_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit.prod_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.prod_id = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('prod_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit.prod_id = '';
//                        vm.model.edit.prod_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                operationService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ANGULAR LIFE CYCLE FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadUnits();
//            };

//            // #endregion ANGULAR LIFE CYCLE FUNCTION

//        }]
//    });
//})();
